import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as allocation from '../allocation'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: allocation.RESOURCE.payload.dimension.partialId,
      partialId: allocation.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Indicates whether this allocation is currently active for the employee.',
    isOptional: true,
    name: 'Is Current',
    partialId: PartialId.Standard.create('is_current'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
